var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3894 13.1106C22.2789 7.64883 18.5724 2.5001 13.1106 1.61059C7.64882 0.721088 2.5001 4.42764 1.61059 9.88941C0.721086 15.3512 4.42764 20.4999 9.88941 21.3894C15.3512 22.2789 20.4999 18.5724 21.3894 13.1106Z",
    fill: "#C11B17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2602 12.5956C18.867 8.86597 16.3354 5.3506 12.6057 4.74385C8.87601 4.13711 5.36064 6.66874 4.75389 10.3984C4.14714 14.1281 6.67878 17.6435 10.4085 18.2502C14.1381 18.857 17.6535 16.3253 18.2602 12.5956Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1366 11.4978C16.1382 12.4122 15.8685 13.3065 15.3616 14.0675C14.8547 14.8285 14.1335 15.4221 13.2892 15.7731C12.4449 16.124 11.5154 16.2167 10.6184 16.0393C9.72142 15.8618 8.89722 15.4223 8.25012 14.7763C7.60301 14.1303 7.16207 13.3068 6.98312 12.4101C6.80416 11.5134 6.89522 10.5838 7.24477 9.7389C7.59433 8.89398 8.18667 8.17175 8.94683 7.66359C9.70699 7.15543 10.6008 6.88418 11.5152 6.88418C12.7395 6.88418 13.9138 7.37001 14.7803 8.235C15.6468 9.1 16.1346 10.2735 16.1366 11.4978Z",
    fill: "#C11B17"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.e48a11ef123b14a53f025b5078155be9.svg";
export { ForwardRef as ReactComponent };